import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "formErrors", "loadingModal", "dataImportLoading" ]
  static values = { base64File: String }

  connect() {
    const id = this.loadingModalTarget?.dataset?.processingId
    if (this.hasLoadingModalTarget && id && parseInt(id) > 0) {
      this.loadingModalTarget.style.display = "block"
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.getDataImportCount(id)
    }
  }

  processDataImports(event) {
    const self = this
    this.formErrorsTarget.innerText = ""
    const addressFields = [
      { id: '#data_import_import_type', errorText: 'Tipo não pode ficar vazio' },
      { id: '#data_import_event_edition_id', errorText: 'Edição não pode ficar vazio' },
      { id: '#data_import_archive', errorText: 'Arquivo não pode ficar vazio' }
    ]

    addressFields.forEach(function(item) {
      const value = document.querySelector(item.id)?.value?.trim()
      if (!value) {
        const li = document.createElement("li")
        li.appendChild(document.createTextNode(item.errorText))
        self.formErrorsTarget.appendChild(li)
      }
    })

    if (this.formErrorsTarget.innerText !== "") {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      event.currentTarget.disabled = true

      fetch('/importacoes', {
        method: 'POST',
        headers: {
          "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
          'Accept': 'application/json',
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          data_import: {
            event_edition_id: document.querySelector('#data_import_event_edition_id').value,
            archive_base64: self.base64FileValue,
            archive_file_name: document.querySelector('#data_import_archive').files[0]?.name || 'arquivo.csv',
            import_type: document.querySelector('#data_import_import_type').value,
          }
        })
      })
      .then(function(response) {
        if (response.ok) {
          return response.json()
        } else {
          const li = document.createElement("li")
          li.appendChild(document.createTextNode('Já existe uma importação em andamento, aguarde e tente novamente.'))
          self.formErrorsTarget.appendChild(li)
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })
      .then(function(r){
        if (r) {
          window.onbeforeunload = null
          window.location.reload(true)
        }
      })
    }
  }

  handleFileSelect(evt) {
    const self = this
    const files = evt.target?.files
    if (FileReader && files?.length) {
      const fr = new FileReader()
      fr.onload = function () {
        self.base64FileValue = fr.result
      }
      fr.readAsDataURL(files[0])
    }
  }

  getDataImportCount(data_import_id) {
    const self = this
    fetch(`/importacoes/${data_import_id}`).then(response => {
      return response.json().then(r => {
        const total = r.data_import.total_rows || 1
        const imported = r.data_import.imported_rows || 0
        const percentage = ((imported / total) * 100).toFixed(2)

        document.querySelector("#data-import-progress progress").value = percentage
        document.querySelector("#data-import-progress #progress-bar").innerHTML = percentage + '%'

        self.dataImportLoadingTarget.innerHTML = ''
        if (r.data_import.import_results) {
          r.data_import.import_results.forEach(function(item){
            const user = item.user || {}
            const label = user.email || user.label || '[sem email]'
            self.dataImportLoadingTarget.innerHTML += `<p class="${item.status}">${label}: ${item.message}</p>`
          })
        }

        if (imported < total) {
          setTimeout(() => self.getDataImportCount(r.data_import.id), 2000)
        } else {
          setTimeout(() => {
            alert('Processo de importação finalizado com sucesso')
            window.location.reload()
          }, 2000)
        }
      })
    })
  }
}
